(() => {
  if (window.Shopify?.designMode || window.orAzurStorefrontTrackingLoaded) return;
  window.orAzurStorefrontTrackingLoaded = true;

  function publish(name, properties) {
    // The Shopify pixel manages consent, visitor identity and delivery to PostHog.
    try {
      const result = window.Shopify?.analytics?.publish(name, properties);
      if (result && typeof result.catch === "function") result.catch(() => {});
    } catch (_) {
      // Tracking must never interrupt the visitor's action.
    }
  }

  document.addEventListener("dialog:after-show", (event) => {
    if (event.target instanceof Element && event.target.matches("cart-drawer")) {
      publish("or_azur:cart_drawer_viewed", { location: "cart_drawer" });
    }
  }, true);

  document.addEventListener("click", (event) => {
    const link = event.target instanceof Element ? event.target.closest("a[href]") : null;
    if (!link) return;

    const href = link.getAttribute("href") || "";
    const card = link.closest("product-card, .horizontal-product-card");
    if (card) {
      const url = new URL(link.href, window.location.origin);
      const match = url.pathname.match(/\/products\/([^/]+)/);
      if (match) {
        publish("or_azur:product_clicked", {
          product_handle: match[1],
          name: card.querySelector(".product-title")?.textContent.trim(),
          url: url.origin + url.pathname,
          list_id: card.closest(".shopify-section")?.id
        });
      }
    }
    const footer = link.closest(".shopify-section--footer");
    const store = link.closest("[data-analytics-store]");
    let contactMethod;

    if (/^tel:/i.test(href)) contactMethod = "phone";
    else if (footer && /^mailto:/i.test(href)) contactMethod = "email";
    else if (store && link.matches(".store-locator-mapbox__directions, .store-locator-mapbox__popup-link")) contactMethod = "directions";
    else return;

    if (!footer && !store) return;
    const properties = {
      contact_method: contactMethod,
      location: footer ? "footer" : store.dataset.analyticsStore,
      destination: href,
      store_id: store?.dataset.storeId,
      store_name: store?.dataset.storeName,
      phone_type: contactMethod === "phone" ? (link.dataset.phoneType || (footer ? "customer_service" : "store")) : undefined
    };

    publish("or_azur:contact_clicked", properties);
  }, true);
})();
